"use strict";
/// <reference path="irep.js"/> 
IREP.featureddevices = (function () {


    function getParameterByName(name) {
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
        return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    function init() {

        $(".hideItemCat").hide();
        $(function () {
            $(".featureditemdetails .image").each(function () {
                if ($(this).data("tag") != "") {
                    var tags = $(this).data("tag").split('|');
                    var i;
                    for (i = 0; i < tags.length; ++i) {
                        $(this).append("<img src='../content/images/featureddevices/badges-" + tags[i] + ".png'>");
                    } 
                     
                }
            })
        })
        if (getParameterByName('pv') == '1') {

            $(".hideItemCat").show();
            $(".showItemCat").hide();


        }

        $(".featureditem").each(function () {
            $(this).css("background", "url(../../Content/Images/MSR/201507/FeaturedDevices/Landing%20Thumbs/Thumb-Landing_" + $(this).data("id") + ".jpg)")
        });


        $(".featureditem").click(function () {
            var data = $(this).parent().attr('id');
            $(".category").fadeOut(250);
            $(".headertitle").fadeOut(250);
            if ($("#" + $(this).data("id")).html().indexOf('#bannerNav') == -1)
                {
                $("#bannerNav").remove();
                bannerRotator("#" + $(this).data("id") + " .bannerRotator", 500, 3000, true);
           
            } 
            $("#" + $(this).data("id")).delay(249).fadeIn(250);

            $(".rightheader").hide();
            $(".headertitle").each(function () {
                if (data != 0) {
                    $(".rightheader").show();
                    $(".backToFDevices").show();
                }
                if ($(this).data("id") == data) {
                    $(this).delay(249).fadeIn(250)
                }
            })
            $(".rightbutton").each(function () {
                if ($(this).data("id") == data) {
                    $(this).show();

                }
                else { $(this).hide(); }
            });
            $("html, body").animate({ scrollTop: 0 }, 0);

        });

        $(".backToFDevices").click(function () {
            var data = $(this).data("id");
            $(".backToFDevices").fadeOut(250);
            $(".featureditemdetails").fadeOut(250);
            if ($(this).data("id") == "0") {
                $(".category").fadeIn(250);
                $(".rightheader").hide();
            }
        });

        $(".normaltext").click(function () {
            var data = $(this).data("id");
            $(".featureditemdetails").fadeOut(250)
            $(".normaltext").animate({
                width: 170
            }, 250);
            $(".subtext").animate({
                width: 160
            }, 250);
            $(".selectedText").removeClass("selectedText");

            $(this).animate({
                width: 180
            }, 250);
            $(this).addClass("selectedText");
            $(".category").fadeOut(250);
            $(".headertitle").fadeOut(250);
            $("#" + $(this).data("id")).delay(249).fadeIn(250);
            $(".featureditem").show();

            if ($(this).data("id") == "0") {
                $(".category").fadeIn(250);
                $(".rightheader").hide();
            }
            $(".rightbutton").each(function () {
                if ($(this).data("id") == data) {
                    $(this).show();
                   
                }
                else
                { $(this).hide(); }
            });


            $(".headertitle").each(function () {
                if (data !=0) {
                    $(".rightheader").show();
                }
                if ($(this).data("id") == data)
                { 
                    $(this).delay(249).fadeIn(250)
                }
            })

            if (data == "Tablet")
            {
                $(".subtext").slideToggle(250);
            }

        });

        $(".subtext").click(function () {
            var data = $(this).data("id"); 
                $(".featureditemdetails").fadeOut(250)
                $(".normaltext").animate({
                    width: 170
                }, 250);
                
                $(".subtext").animate({
                    width: 160
                }, 250);
                $(".selectedText").removeClass("selectedText");

                $(this).animate({
                    width: 170
                }, 250);
                $(this).addClass("selectedText");
                $(".category").fadeOut(250);
                $(".headertitle").fadeOut(250);
                $("#" + $(this).data("id")).delay(249).fadeIn(250); 
                $("#Tablet").delay(249).fadeIn(250);

                if ($(this).data("id") == "0") {
                    $(".category").fadeIn(250);
                    $(".rightheader").hide();
                }
                $(".headertitle").each(function () { 
                        $(".rightheader").show(); 
                    if ($(this).data("id") == "Tablet")
                    { 
                        $(this).delay(249).fadeIn(250);
                        setTimeout(function(){ $(".featureditem").each(function () {
                            if (data == $(this).data("tag")) {
                                $(this).show();
                            }
                            else {
                                $(this).hide();
                            }
                        })}, 300);  
                        
                    }
                    
                })


                $(".rightbutton").each(function () {
                    if ($(this).data("id") == "Tablet") {
                        $(this).show();

                    }
                    else { $(this).hide(); }
                });

        });
    }
    return {
        init: init
    };
})();